import { Link } from "react-router-dom";
import { useStore } from "../lib/storeContext";
import { EmptyState, Spinner } from "./ui";
import { pluralize } from "../lib/util";
import { DeleteButton } from "./DeleteButton";

export function ProjectsView() {
  const { store, rev, loading, error } = useStore();
  void rev;

  if (loading) return <Spinner label="Loading your projects…" />;
  if (error) return <EmptyState title="Couldn’t load" subtitle={error} icon="⚠️" />;

  const projects = store.projects();
  if (projects.length === 0) {
    return (
      <EmptyState
        icon="🏠"
        title="No projects yet"
        subtitle="Create a project in the AI Home Decorator app and it’ll show up here."
      />
    );
  }

  return (
    <div>
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-bold text-ink">Projects</h1>
          <p className="text-sm text-muted">{pluralize(projects.length, "project")}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {projects.map((p) => {
          const rooms = store.rooms(p.id);
          const hasStructure = !!p.payload.mergedStructureUSDZFileName;
          const located = p.payload.latitude != null && p.payload.longitude != null;
          const membership = store.membership(p.id); // set ⇒ shared WITH me (I'm editor/viewer)
          return (
            <div key={p.id} className="relative">
              <Link
                to={`/projects/${p.id}`}
                className="card group flex h-full flex-col gap-3 p-5 transition hover:shadow-lift"
              >
                <div className="flex items-start justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-warm text-2xl text-white">
                    {located ? "📍" : "🏠"}
                  </div>
                  <div className="flex items-center gap-1.5">
                    {membership && <span className="chip capitalize">{membership.role}</span>}
                    {hasStructure && <span className="chip">3D home</span>}
                  </div>
                </div>
                <div>
                  <div className="text-lg font-semibold text-ink group-hover:text-accent">{p.payload.name || "Untitled"}</div>
                  <div className="mt-0.5 line-clamp-1 text-sm text-muted">
                    {p.payload.address || "No address"}
                  </div>
                  {membership && (
                    <div className="mt-0.5 text-xs text-muted">
                      Shared by {membership.ownerName || "the owner"}
                    </div>
                  )}
                </div>
                <div className="mt-auto text-sm text-muted">{pluralize(rooms.length, "room")}</div>
              </Link>
              <div className="absolute bottom-3 right-3 rounded-full bg-white/85 backdrop-blur">
                <DeleteButton type="PROJECT" id={p.id} what="project" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
